import { useContext, useState } from "react";

import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";

import { C, themeClasses } from "sj-ui-toolkit/src/atlas/utils";

import { VideoContext } from "../../VideoContext";
import FeedbackPage from "../../../../Feedback/FeedbackPage";

import S from "./_styles.module.scss";

export default function QuizQuestion({ answersCount, questionsCount }) {
  const {
    quiz,
    onQuestionSubmit,
    onQuestionContinue,
    selectedOption,
    onAnswerSelect,
    submissionData,
  } = useContext(VideoContext);
  const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false);

  const onSubmit = async () => {
    setIsFeedbackLoading(true);
    await onQuestionSubmit();
    setIsFeedbackLoading(false);
  };

  return (
    <>
      <h2 className="atlas-h5 p-4 text-muted">
        Question {answersCount + 1} of {questionsCount}
      </h2>
      <div className={S.quizBody}>
        <span className="body-lg">{quiz.question?.text}</span>
        <fieldset className="flex flex-col gap-4">
          {quiz.question?.answers.map((answer, index) => (
            <div key={index}>
              <label className="flex items-center gap-2">
                <RadioButton
                  inputId={`radio-${index}`}
                  value={answer.slug}
                  checked={selectedOption === answer.slug}
                  onChange={() => onAnswerSelect(answer.slug)}
                  aria-describedby={`answer-description-${index}`}
                  data-testid={`mc-answer-${index}`}
                />
                {answer.text}
              </label>
              <span id={`answer-description-${index}`} className={S.visuallyHidden}>
                {answer.choice} vulnerability.
              </span>
            </div>
          ))}
        </fieldset>
        {submissionData?.feedback && (
          <div
            className={C("flex items-center gap-2 p-4 w-fit rounded-sm", themeClasses.bgElevation3)}
          >
            {submissionData.isCorrect ? (
              <i className="pi pi-check text-success"></i>
            ) : (
              <i className="pi pi-times text-danger"></i>
            )}
            <span>{submissionData.feedback}</span>
          </div>
        )}
      </div>
      <div className={S.quizFooter}>
        <div className="flex justify-between">
          <Button
            label="Provide question feedback"
            link
            onClick={() => setFeedbackModalVisible(true)}
          />
          {submissionData ? (
            <Button label="Continue" onClick={onQuestionContinue} />
          ) : (
            <Button
              label="Submit"
              icon="pi pi-check"
              onClick={onSubmit}
              disabled={!selectedOption}
              loading={isFeedbackLoading}
            />
          )}
        </div>
      </div>

      <Dialog
        header="Feedback"
        visible={feedbackModalVisible}
        onHide={() => setFeedbackModalVisible(false)}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      >
        <FeedbackPage forQuiz={true} />
      </Dialog>
    </>
  );
}
